
import Vue from 'vue'
import * as httpConst from '../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/providers`

const tenantProvider = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    destroy ({ commit }, { provider }) {
      const api_path = `${API_PATH}/${provider}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '連携を解除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
  }
}
export default tenantProvider
